import { SmoothScroll } from ".";

export class Newsletter {
  smoothScroll: SmoothScroll;

  buttons: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-newsletter-button]",
  );
  modal: HTMLElement | null = document.querySelector(
    '[data-modal-for="newsletter"]',
  );
  newsletterSubscriptionContent: HTMLElement | null = document.getElementById(
    "newsletter-subscription",
  );
  newsletterForm: HTMLFormElement | null = document.getElementById(
    "newsletter-form",
  ) as HTMLFormElement | null;
  newletterEmailInput: HTMLInputElement | null = document.getElementById(
    "newsletter-email",
  ) as HTMLInputElement | null;
  newsletterModalDisclaimer: HTMLElement | null = document.querySelector(
    ".newsletter-modal-disclaimer",
  );
  newsletterModalDisclaimerText: HTMLElement | null = document.querySelector(
    ".newsletter-modal-disclaimer > span",
  );
  newsletterSubscriptionSuccessContent: HTMLElement | null =
    document.getElementById("newsletter-subscription-success");
  errorMessageElement: HTMLElement | null = document.getElementById(
    "newsletter-error-message",
  );
  newsletterSubmitButton: HTMLButtonElement | null = document.getElementById(
    "newsletter-submit-button",
  ) as HTMLButtonElement | null;

  constructor(smoothScroll: SmoothScroll) {
    this.smoothScroll = smoothScroll;

    this.init();
  }

  init = () => {
    this.initModal();
    this.initModalsControls();
  };

  initModal = () => {
    if (!this.modal) {
      return;
    }

    const modalBackdrop = this.modal.querySelector(
      "[data-modal-backdrop]",
    ) as HTMLElement;

    modalBackdrop.addEventListener("click", this.close);

    const closeModalButtons = this.modal.querySelectorAll(
      "[data-modal-close]",
    ) as NodeListOf<HTMLElement>;

    closeModalButtons.forEach((button) => {
      button.addEventListener("click", () => {
        button.blur();
        this.close();
      });
    });

    this.setNewsletterModalDisclaimerHeight();

    const newsletterModalDisclaimerTextResizeObserver = new ResizeObserver(
      this.setNewsletterModalDisclaimerHeight,
    );

    if (this.newsletterSubscriptionContent) {
      newsletterModalDisclaimerTextResizeObserver.observe(
        this.newsletterSubscriptionContent,
      );
    }

    this.newletterEmailInput?.addEventListener(
      "focus",
      this.showNewsletterModalDisclaimer,
    );

    /*
    this.newsletterForm?.addEventListener("submit", (event) => {
      event.preventDefault();

      // demo loading state
      this.newsletterSubmitButton?.classList.add(
        "page-button-primary--loading",
      );

      setTimeout(this.showNewsletterSubscriptionSuccess, 2500);
    });
    */

    window.addEventListener("keydown", this.onWindowKeyDown);
  };

  initModalsControls = () => {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.open);
    });
  };

  setNewsletterModalDisclaimerHeight = () => {
    if (
      !this.newsletterModalDisclaimer ||
      !this.newsletterModalDisclaimerText
    ) {
      return;
    }

    const contentHeight = this.newsletterModalDisclaimerText.offsetHeight;

    this.newsletterModalDisclaimer.style.setProperty(
      "--content-height",
      `${contentHeight}px`,
    );
  };

  showNewsletterModalDisclaimer = () => {
    if (!this.newsletterModalDisclaimer) {
      return;
    }

    this.newsletterModalDisclaimer.addEventListener(
      "transitionend",
      () => {
        this.newsletterModalDisclaimer!.classList.add(
          "newsletter-modal-disclaimer--visible",
        );
      },
      {
        once: true,
      },
    );

    this.newsletterModalDisclaimer.removeAttribute("aria-hidden");
    this.newsletterModalDisclaimer.classList.remove(
      "newsletter-modal-disclaimer--hidden",
    );
  };

  /*
  showNewsletterSubscriptionSuccess = () => {
    if (this.newsletterSubscriptionContent) {
      this.newsletterSubscriptionContent.classList.add(
        "newsletter-modal-content-hidden",
      );
    }

    if (this.newsletterSubscriptionSuccessContent) {
      this.newsletterSubscriptionSuccessContent.classList.remove(
        "newsletter-modal-content-hidden",
      );
    }
  };
   */

  open = () => {
    if (!this.modal) {
      return;
    }

    const otherOpenModals = document.querySelectorAll(
      ".page-modal--open:not([data-modal-for=\"newsletter\"])",
    );

    otherOpenModals.forEach((modal) => {
      modal.setAttribute("aria-hidden", "true");
      modal.classList.remove("page-modal--open");
    });

    this.modal.setAttribute("aria-hidden", "false");
    this.modal.classList.add("page-modal--open");
    this.smoothScroll.toggleLenisDocumentBodyScroll(false);
  };

  close = () => {
    if (!this.modal) {
      return;
    }

    this.modal.setAttribute("aria-hidden", "true");
    this.modal.classList.remove("page-modal--open");
    this.smoothScroll.toggleLenisDocumentBodyScroll(true);
  };

  onWindowKeyDown = (event: KeyboardEvent) => {
    if (
      event.key === "Escape" &&
      this.modal?.classList.contains("page-modal--open")
    ) {
      this.close();
    }
  };
}
